import { useContext, useState } from 'react';
import { toast } from 'react-toastify';

import { resendVerificationLink } from '../api';
import { UserContext } from '../context';

const useEmailVerification = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useContext(UserContext);

  const emailVerification = async () => {
    setIsLoading(true);
    const email = user.email;
    try {
      await resendVerificationLink();
      toast.success(`Kindly check your email ${email} to verify your account`);
    } catch (error) {
      const {
        response: {
          data: { message }
        }
      } = error;

      toast.error(message);
    }
    setIsLoading(false);
  };

  return { isLoading, emailVerification };
};

export { useEmailVerification };
